// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qOCyff {\n    position: relative;\n    z-index: 99999;\n    font-family: Madefor-Text, Madefor;\n}\n\n.k5W_vM,\n.k5W_vM * {\n    font-family: Madefor-Text, Madefor;\n}\n\n.RBEmL6 {\n    display: none;\n}\n\n.qOCyff a {\n    color: #000;\n}\n\n.qOCyff button {\n    height: 36px;\n    font-family: Madefor-Text, Madefor;\n    font-size: 14px;\n}\n\n@media (max-width: 375px) {\n    .qOCyff {\n        font-family: Madefor-Text, Madefor;\n        font-size: 13px;\n    }\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "qOCyff",
	"fontFallback": "k5W_vM",
	"hidden": "RBEmL6"
};
export default ___CSS_LOADER_EXPORT___;
